export default "__VITE_ASSET__ClxtmMT0__"